<template>
    <div>

        <vue-bootstrap4-table :rows="sessions" :columns="dt.columns" :config="dt.config" :classes="dt.classes" :actions="dt.actions" @on-refresh="refresh">
            <template slot="sort-asc-icon">
                <i class="fas fa-sort-up"></i>
            </template>
            <template slot="sort-desc-icon">
                <i class="fas fa-sort-down"></i>
            </template>
            <template slot="no-sort-icon">
                <i class="fas fa-sort"></i>
            </template>

            <template slot="detail" slot-scope="props">
                <div v-for="session in props.row.sessions">
                    ({{session.ip_address}}) {{ session.last_activity }}
                </div>
            </template>
            <template slot="session" slot-scope="props">
                <span>{{ props.row.sessions.length }}</span>
            </template>
            <template slot="action" slot-scope="props">
                <button class="btn btn-sm btn-primary" @click.prevent="kick(props.row.id)">Clear All Sessions</button>
            </template>
        </vue-bootstrap4-table>

    </div>
</template>

<script>

    import VueBootstrap4Table from 'vue-bootstrap4-table'
    /*var moment = require('moment')
    moment().format()*/


	export default {
		name: "UserSessionManagement",
        props: {
            id: {
                type: String,
                // Object or array defaults must be returned from
                // a factory function
            },
        },
        data() {
		    return {
		        sessions: [],

                dt: {
                    classes: {
                        table: {
                            "table-striped": true,
                        }
                    },
                    columns: [
                        {
                            label: "Name",
                            name: "first_name",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Company",
                            name: "last_name",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Email",
                            name: "email",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Active Sessions",
                            name: "sessions",
                            sort: true,
                            initial_sort: true, // "false" by default
                            initial_sort_order: "desc", // "asc" by default
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                            slot_name: "session"
                        },
                        {
                            label: "IP & Last Activity",
                            name: "sessions",
                            sort: false,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                            slot_name: "detail"
                        },
                        {
                            label: "Actions",
                            name: "sessions",
                            sort: false,
                            row_text_alignment:  "text-right",
                            column_text_alignment:  "text-right",
                            slot_name: "action"
                        },

                    ],
                    config: {
                        per_page: 50,
                        card_mode: false,
                        show_refresh_button: false,
                        show_reset_button: false,
                        per_page_options:  [50,  100,  200,  500],
                    },
                    actions: [
                        {
                            btn_text: "Refresh",
                            event_name: "on-refresh",
                            class: "btn btn-outline-primary",
                            event_payload: {
                                //msg: "my custom msg"
                            }
                        }
                    ],
                },
            }
        },
        mounted() {
            this.refresh()
        },
        methods: {
            /*moment(date) {
                return moment(date)
            },*/
            refresh()
            {
                axios.get('/api/session/'+this.id).then((response) => {
                    this.sessions = response.data.sessions
                }).catch((error) => {
                });
            },
            kick(id)
            {
                axios.patch('/api/session/'+id+'/clear').then((response) => {
                    this.refresh()
                }).catch((error) => {
                });
            }
        }
    }
</script>

<style scoped>

</style>
